import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { debug } from 'console';

@Injectable({
  providedIn: 'root'
})

export class StudentLedgerpdfService {
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  constructor(private http: HttpClient) { }

  GetYearWiseCourses(ShiftId: number, YearCode: number, YearAllWise: string): Observable<any> {
    debugger;
    //console.log(this.baseURL + '/GetYearWiseCourses?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&YearAllWise=' + YearAllWise);
    return this.http.get<any>(this.baseURL + '/GetYearWiseCourses?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&YearAllWise=' + YearAllWise)
      .pipe(retry(1), catchError(this.handleError));
  }

  //ViewStudLedgerDet(Admno: string, YearCode: Number): Observable<any> {
  ViewStudLedgerDet(ShiftId: number, YearCode: number, CSCode: string, selectedLeft: number): Observable<any> {
    debugger;
    //console.log(this.baseURL + '/ViewStudFeeDetailsDetAlls?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode)
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAlls?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&selectedLeft=' + selectedLeft)
    .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudLedgerDetC(ShiftId: number, YearCode: number, CSCode: string, FilterAmt: number, selectedLeft: number): Observable<any> {
    debugger;
    //console.log(this.baseURL + '/ViewStudFeeDetailsDetAllsC?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&FilterAmt=' + FilterAmt);
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllsC?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&FilterAmt=' + FilterAmt + '&&selectedLeft=' + selectedLeft)
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudLedgerDetSum(ShiftId: number, YearCode: number, CSCode: string, selectedLeft: number): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllSum?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&selectedLeft=' + selectedLeft)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetCourses(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetCourses?YearCode=' + parseInt(sessionStorage.getItem('YearCode')))
      .pipe(retry(1), catchError(this.handleError));
  }

  GetCoursesC(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetCoursesC?YearCode=' + parseInt(sessionStorage.getItem('YearCode')))
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudFeeDetailsDet(Admno: string,YearCode: Number): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDet?Admno=' + Admno + '&&YearCode=' + YearCode);
  }
  ViewStudFeeDetailsDetAll(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAll')
    .pipe(retry(1), catchError(this.handleError));
  }
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
